// extracted by mini-css-extract-plugin
module.exports = {"accessibleText":"MobileBurgerButton_accessibleText__K3kgD","hamburger":"MobileBurgerButton_hamburger__3S5at","hamburgerBox":"MobileBurgerButton_hamburgerBox__Mm1G3"};